function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 307,
  cy: 26,
  r: 15,
  fill: "#00254C"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 207.5,
  cy: 206.5,
  stroke: "#00254C",
  strokeWidth: 2,
  opacity: 0.598,
  rx: 206.5,
  ry: 205.5
}));

function SvgGroup42(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 415 413"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0MTUgNDEzIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGc+CiAgICAgICAgICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKC03NzMgLTgxNzYpIHRyYW5zbGF0ZSg3NzMgODE3NikiPgogICAgICAgICAgICAgICAgPGNpcmNsZSBjeD0iMzA3IiBjeT0iMjYiIHI9IjE1IiBmaWxsPSIjMDAyNTRDIi8+CiAgICAgICAgICAgICAgICA8ZWxsaXBzZSBjeD0iMjA3LjUiIGN5PSIyMDYuNSIgc3Ryb2tlPSIjMDAyNTRDIiBzdHJva2Utd2lkdGg9IjIiIG9wYWNpdHk9Ii41OTgiIHJ4PSIyMDYuNSIgcnk9IjIwNS41Ii8+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPgo=";
export { SvgGroup42 as ReactComponent };